import { AbstractGetAllStore } from "../common/AbstractStores";
import Dispatcher from "../common/dispatcher";
import Actions from "./marcheClimaActions";
import CaldaieActions from "../modelliClima/ModelliClimaActions";

class MarcheClimaStore extends AbstractGetAllStore<string> {
    constructor() {
        super(x => x);
        Dispatcher
            .onfunction(Actions.getAll, result => this.setAll(result))
            .onfunction(CaldaieActions.add, result => this.updateOrAdd(result.marca!))
            .onfunction(CaldaieActions.update, result => this.updateOrAdd(result.marca!))

    }
    public useAll = () => this.useAllWithAction(() => Actions.getAll());
}

export default new MarcheClimaStore()
